import React from 'react'
import './HomePage.css';
import EnterPage from '../EnterPage/EnterPage';
import Contact from '../../Components/contact/Contact';
import Header from '../../Components/header/Header';
import Experiense from '../../Components/Experience/Experience';
import Services from '../../Components/services/Services';
import Footer from '../../Components/Footer/Footer';
import Gallery from '../../Components/Gallery/Gallery';
import Nav from '../../Components/nav/Nav';
import ContactData from '../../Components/ContactData/ContactData';
import FooterEnds from '../../Components/FooterEnds/FooterEnds';
import { HelmetProvider } from 'react-helmet-async';
import { Helmet } from 'react-helmet';




const HomePage = () => {

    return (
        <>
            <HelmetProvider>
                <Helmet>
                    <title>Mohamed Metwally's Portfolio</title>
                    <link rel="canonical" href="https://mohammed-metwally.web.app/Gallery" />
                    <meta name="description" content="Discover the innovative work of Mohamed Metwally, where innovation meets expertise in front-end web development. Dive into a showcase of dynamic, responsive web applications crafted with React.js, GSAP, and Tailwind CSS. Explore Mohamed’s diverse projects that highlight his commitment to creating seamless, user-centric experiences. Whether you’re looking for inspiration, interested in collaboration, or seeking top-tier web solutions, this site offers a comprehensive look at Mohamed’s skills and achievements. Discover how his passion for technology and design can bring your ideas to life, and find the contact information to start your next project. Explore, connect, and see how Mohamed can elevate your digital presence." />
                </Helmet>
            </HelmetProvider>
            <div className="Home" >
                <Nav />
                <Header />
                <EnterPage />
                <div id='about__me'>
                    <Contact />
                </div>
                <Experiense />
                <Services />
                <div id='Galleryy'>
                    <Gallery />
                </div>
                <ContactData />
                <Footer />
                <FooterEnds />
            </div>
        </>
    );
};

export default HomePage;
